import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ FETCH COMPANY USERS
 * Active Reader/Approver/Manager assignments for one CorporateEntity.
 */
export const fetchCompanyUsers = async (corporateEntityId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/company-users/get-by-company",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ CorporateEntityId: corporateEntityId })
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Company Users Fetch Failed:", err);
        return [];
    }
};

/**
 * 🛰️ ASSIGN COMPANY USER ROLE
 */
export const assignCompanyUserRole = async (corporateEntityId, siteUserGuid, companyRoleCode, config) => {
    try {
        const payload = {
            CorporateEntityId: corporateEntityId,
            SiteUserGuid: siteUserGuid,
            CompanyRoleCode: companyRoleCode
        };

        const rawData = await dbPayload(
            "/api/v1/sustina/company-users/assign",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Company user assignment failed.");
        return res.data;
    } catch (err) {
        console.error("Company User Assignment Error:", err);
        throw err;
    }
};

/**
 * 🛰️ REVOKE COMPANY USER ROLE
 */
export const revokeCompanyUserRole = async (corporateEntityId, siteUserGuid, companyRoleCode, config) => {
    try {
        const payload = {
            CorporateEntityId: corporateEntityId,
            SiteUserGuid: siteUserGuid,
            CompanyRoleCode: companyRoleCode
        };

        const rawData = await dbPayload(
            "/api/v1/sustina/company-users/revoke",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Company user revoke failed.");
        return true;
    } catch (err) {
        console.error("Company User Revoke Error:", err);
        throw err;
    }
};

/**
 * 🛰️ SEARCH USERS (reused, read-only, shared search endpoint — safe, not part
 * of the multi-tenant matrix/assignment system)
 */
export const searchUsers = async (searchTerm, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/manage-users/search",
            "POST",
            config.siteKey,
            { SearchTerm: searchTerm }
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("User Search Failed:", err);
        return [];
    }
};
